var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item",class:_vm.filter.sort.title == 'Shuffle' ? 'active' : '',on:{"click":function($event){return _vm.activateSortFilter('sort', 'random', 'DESC', 'Shuffle', _vm.query);}}},[_c('span',[_vm._v("Shuffle")])])}
var staticRenderFns = []

export { render, staticRenderFns }